class SizeChartContent extends HTMLElement {
  constructor() {
    super();

    this.toggleContainer = this.querySelector('.size-chart-toggle');
    this.toggleInput = this.querySelector('#SizeChartToggle');
    this.sizeChart = this.querySelector('table');
    this.sizeChartWrapper = this.querySelector('.size-chart');
    this.scrollToStartBtn = this.querySelector('button[data-action="scroll-start"]');
    this.scrollToEndBtn = this.querySelector('button[data-action="scroll-end"]');
  }

  connectedCallback() {
    this.toggleInput.addEventListener('change', this.convertMeasurements.bind(this));
    this.sizeChartWrapper.addEventListener('scroll', this._debounce(this.onChartScroll.bind(this), 50));
    this.scrollToStartBtn.addEventListener('click', this.scrollToStart.bind(this));
    this.scrollToEndBtn.addEventListener('click', this.scrollToEnd.bind(this));
  }

  _getUnits() {
    if (this.toggleInput.checked) {
      return 'cm';
    } else {
      return 'in';
    }
  }

  _debounce(func, delay) {
    let timeoutId;
    return function () {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(func, delay);
    };
  }

  convertMeasurements() {
    const conversion = this._getUnits() == 'cm' ? 2.54 : 0.3937007874;
    const cellsToConvert = this.querySelectorAll('table td:not(:first-of-type)');
    // const cellsToConvert = this.querySelectorAll('table tr:not(:first-of-type) > td:not(:first-of-type)');
    cellsToConvert.forEach(cell => {
      if (!isNaN(parseInt(cell.textContent))) {
        cell.textContent = parseFloat(parseFloat(parseFloat(cell.textContent * conversion).toFixed(2)).toFixed(2)).toFixed(2);
      }
    });
    this.setActiveUnits();
  }

  setActiveUnits() {
    this.toggleContainer.querySelectorAll('.toggle__label').forEach(label => {
      label.setAttribute('data-selected', 'false')
    });

    this.toggleContainer.querySelector(`.toggle__label[data-units="${this._getUnits()}"]`).setAttribute('data-selected', 'true');
    this.toggleContainer.querySelector('[data-a11y]').textContent = this._getUnits() === 'cm' ? 'Convert measurements to inches' : 'Convert measurements to centimeters';
  }

  onChartScroll() {
    const scrollPosition = this.sizeChartWrapper.scrollLeft;
    const contentWidth = this.sizeChartWrapper.scrollWidth - this.sizeChartWrapper.clientWidth;

    console.log({ contentWidth }, { scrollPosition });

    let scrollAttribute;

    if (scrollPosition === 0) {
      scrollAttribute = 'start';
      this.scrollToStartBtn.setAttribute('aria-disabled', 'true');
      this.scrollToEndBtn.setAttribute('aria-disabled', 'false');
    } else if (scrollPosition >= contentWidth) {
      scrollAttribute = 'end';
      this.scrollToEndBtn.setAttribute('aria-disabled', 'true');
      this.scrollToStartBtn.setAttribute('aria-disabled', 'false');
    } else {
      scrollAttribute = 'scrolling';
      this.scrollToEndBtn.setAttribute('aria-disabled', 'false');
      this.scrollToStartBtn.setAttribute('aria-disabled', 'false');
    }

    this.setAttribute('data-scroll-position', scrollAttribute);
  }

  scrollToStart() {
    this.sizeChartWrapper.scrollLeft = 0;
  }

  scrollToEnd() {
    this.sizeChartWrapper.scrollLeft = this.sizeChartWrapper.scrollWidth - this.sizeChartWrapper.clientWidth;
  }
}

customElements.define('size-chart-content', SizeChartContent);